import { render, staticRenderFns } from "./Sfdc.vue?vue&type=template&id=8a2b941c&scoped=true"
import script from "./Sfdc.vue?vue&type=script&lang=js"
export * from "./Sfdc.vue?vue&type=script&lang=js"
import style0 from "./Sfdc.vue?vue&type=style&index=0&id=8a2b941c&prod&lang=scss&scoped=true"
import style1 from "./Sfdc.vue?vue&type=style&index=1&id=8a2b941c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2b941c",
  null
  
)

export default component.exports